import ZoneHeadStudentList from '../../features/zoneHead/ZoneHeadStudentList'

const ZoneHeadStudentListPage = () => {
    return <ZoneHeadStudentList />
}

export default ZoneHeadStudentListPage